// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-terms-of-use {
  height: 564px !important;
  max-width: 95% !important;
  top: 2%;
}
.modal-terms-of-use .ant-modal-close {
  inset-inline-end: 4% !important;
}
.modal-terms-of-use .ant-modal-footer {
  position: absolute;
}
.modal-terms-of-use .container-spa {
  margin-top: 3%;
  text-align: center;
  align-items: center;
  justify-content: center;
  font: normal normal 400 10px Poppins;
  color: #FFFFFF;
}
.modal-terms-of-use .banner-container {
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 440px) {
  .modal-terms-of-use .banner-container img {
    width: 90vw !important;
    height: auto !important;
  }
}
.modal-terms-of-use .banner-container img {
  width: 530px;
  height: 400px;
  border-radius: 10px;
  /* Você pode ajustar esse valor conforme necessário */
}
.modal-terms-of-use .btn-accept {
  font-size: 12px !important;
  margin: auto;
  width: 60%;
  height: 6vh !important;
}
@media screen and (max-width: 498px) {
  .modal-terms-of-use .btn-accept {
    font-size: 9px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Modal/ModalPopBallonStyles.less"],"names":[],"mappings":"AAAA;EACI,wBAAA;EACA,yBAAA;EAMA,OAAA;AAJJ;AAJA;EAKQ,+BAAA;AAER;AAPA;EAYQ,kBAAA;AAFR;AAVA;EAgBQ,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;AAHR;AAlBA;EAyBQ,aAAA;EACA,uBAAA;AAJR;AAOI;EAAA;IAEQ,sBAAA;IACA,uBAAA;EALV;AACF;AA5BA;EAwCQ,YAAA;EACA,aAAA;EACA,mBAAA;EATN,qDAAqD;AACvD;AAlCA;EA+CQ,0BAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;AAVR;AAYQ;EAAA;IACI,yBAAA;EATV;AACF","sourcesContent":[".modal-terms-of-use {\n    height: 564px !important;\n    max-width: 95% !important;\n\n    .ant-modal-close {\n        inset-inline-end: 4% !important;\n    }\n\n    top: 2%;\n\n\n    .ant-modal-footer {\n        position: absolute;\n    }\n\n    .container-spa {\n        margin-top: 3%;\n        text-align: center;\n        align-items: center;\n        justify-content: center;\n        font: normal normal 400 10px Poppins;\n        color: #FFFFFF;\n    }\n\n    .banner-container {\n        display: flex;\n        justify-content: center;\n    }\n\n    @media screen and (max-width: 440px) {\n        .banner-container img {\n            width: 90vw !important;\n            height: auto !important;\n\n        }\n    }\n\n    .banner-container img {\n        // max-width: 100%;\n        // height: auto;\n        width: 530px;\n        height: 400px;\n        border-radius: 10px;\n        /* Você pode ajustar esse valor conforme necessário */\n    }\n\n    .btn-accept {\n        font-size: 12px !important;\n        margin: auto;\n        width: 60%;\n        height: 6vh !important;\n\n        @media screen and (max-width: 498px) {\n            font-size: 9px !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
